import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { isAuthenticated } from "../auth";
import { AddPubC400X400 } from "../auth/apiCategory";
import { MdEdit, MdRemoveRedEye, MdClose } from "react-icons/md";
import { FaRegImage } from "react-icons/fa";
import ErrorAlert from "./ErrorAlert";
import "./imagesLoading.css";
import "./PubUploadForm.css";
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["pubC400X400"]?.[key] || fallback;

const Pubc500x500 = (props) => {
  const { token } = isAuthenticated();

  const [days, setDays] = useState(1);
  const [error, setError] = useState(null);

  const [viewImageModal, setViewImageModal] = useState(null);
  const [editImageIndex, setEditImageIndex] = useState(null);

  const [post, setPost] = useState({ photos: [] });
  const { photos } = post;

  const [highlight, setHighlight] = useState(false);
  const fileInputRef = useRef(null);

  const {
    categories_ID,
    infoSource,
    elakayCategoryID,
    loadCategory,
    ButtonCancel,
  } = props;
  __setElakayInfoSource(infoSource);

  const maxImgSize = 1;

  // ---------- Helpers UI ----------
  const formatBytes = (bytes = 0) => {
    if (!bytes) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
  };

  const previewCardStyle = (img) => ({
    aspectRatio: img?.naturalW && img?.naturalH ? `${img.naturalW} / ${img.naturalH}` : "1 / 1",
  });

  // ---------- Upload core ----------
  const openFilePicker = () => fileInputRef.current?.click();

  const handleHighlight = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(true);
  };

  const handleUnhighlight = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
    handleFiles(e.dataTransfer.files);
  };

  const handleFileChange = (e) => {
    handleFiles(e.target.files);
    // ✅ permet de re-choisir le même fichier ensuite
    e.target.value = "";
  };

  const handleFiles = (files) => {
    const incoming = Array.from(files || []);
    if (!incoming.length) return;

    // ✅ une seule image
    const file = incoming[0];

    // si déjà une image et user essaye d’en ajouter encore
    if (photos.length >= 1) {
      setError([
        elakayAutoText("h_d89bb00112acfd", "⚠️ Only 1 image is allowed."),
        elakayAutoText("h_e8f062c31ba45b", "Please delete the current image before uploading a new one."),
      ]);
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const img = new Image();

      img.onload = () => {
        const naturalW = img.width;
        const naturalH = img.height;

        // ✅ Validation 500x500
        if (naturalW !== 500 || naturalH !== 500) {
          setError([
            elakayAutoText("h_a11984eea85d1d", "❌ Invalid image size."),
            elakayAutoText("h_f5f66825af791b", "Accepted format:"),
            elakayAutoText("h_d989823e9762e4", "• 500 × 500 pixels"),
            "",
            elakayAutoText("h_f24a26cc64d41d", "Your image \"{value0}\":", { value0: file.name }),
            elakayAutoText("h_974e1649717baa", "• {value0} × {value1} ❌", { value0: naturalW, value1: naturalH }),
          ]);
          return;
        }

        setError(null);

        setPost({
          photos: [
            {
              file,
              name: file.name,
              type: file.type,
              size: file.size,
              src: reader.result,
              naturalW,
              naturalH,
            },
          ],
        });
      };

      img.onerror = () => setError([elakayAutoText("h_f5956c5ad4524f", "❌ This file is not a valid image.")]);
      img.src = reader.result;
    };

    reader.onerror = () => setError([elakayAutoText("h_30f2044446be6b", "❌ Cannot read this file.")]);
    reader.readAsDataURL(file);
  };

  const handleDelete = () => {
    setPost({ photos: [] });
    setError(null);
    setEditImageIndex(null);
    setViewImageModal(null);
  };

  // ---------- Submit ----------
  const handleSubmit = async () => {
    try {
      if (!photos?.length) {
        setError([elakayAutoText("h_a76939c283a6ec", "⚠️ Please upload one image (500×500) before submitting.")]);
        return;
      }

      const f = photos[0];

      const data = await AddPubC400X400(token, days, elakayCategoryID, f.file);

      if (!data || data.error || data.success === false) {
        setError(data?.error || data?.errors || [elakayAutoText("h_ad0d0603e2aad1", "Upload failed")]);
        return;
      }

      setError(null);
      setPost({ photos: [] });
      loadCategory(categories_ID);
    } catch (err) {
      console.error(err);
      setError([elakayAutoText("h_831b916850bbfe", "Unexpected error")]);
    }
  };

  // ---------- UI pieces ----------
  const nbrDayForm = () => (
    <div className="pub-days-card">
      <span className="pub-days-label">
        {infoSource.laguangeElakay("title", infoSource.languageAPI).nomber}
        <strong>{days}</strong>
        {infoSource.laguangeElakay("title", infoSource.languageAPI).days}
      </span>
      <input
        onChange={(e) => setDays(e.target.value)}
        type="number"
        className="pub-days-input"
        min="1"
        max="99"
        value={days}
      />
    </div>
  );

  const ViewImageModal = () => {
    if (!viewImageModal) return null;

    return (
      <Modal
        show={!!viewImageModal}
        onHide={() => setViewImageModal(null)}
        fullscreen
        contentClassName="pub-modal-shell"
        backdropClassName="pub-modal-backdrop-bs"
      >
        <Modal.Body className="pub-modal-body" onClick={() => setViewImageModal(null)}>
          <div className="pub-modal-content" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="pub-modal-close" onClick={() => setViewImageModal(null)}>
              <MdClose />
            </button>

            <img
              className="pub-modal-image"
              src={viewImageModal.src}
              alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubC400X400.t001}
            />

            <div className="pub-modal-caption">
              <p>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).pubC400X400.t002}</p>
              <p>
                {viewImageModal.naturalW} × {viewImageModal.naturalH}{__elakayText("t003", "px —")}{" "}
                {formatBytes(viewImageModal.size)}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const ImagesForm = () => (
    <div className="m-3">
      <form encType="multipart/form-data">
        {/* Preview */}
        {photos?.length > 0 && (
          <div className="pub-preview-grid">
            {photos.map((a, i) => (
              <div key={i} className="pub-preview-card" style={previewCardStyle(a)}>
                <button type="button" className="pub-preview-delete" onClick={handleDelete}>×</button>

                <span className="pub-preview-filesize">{formatBytes(a.size)}</span>

                <img className="pub-preview-img" src={a.src} alt={a.name} />

                <span className="pub-preview-devicebadge pub-preview-devicebadge--neutral">
                  {a.naturalW}×{a.naturalH}
                </span>

                {editImageIndex === i && (
                  <div className="pub-preview-editoverlay">
                    <MdEdit />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Top actions */}
        {photos.length > 0 && (
          <div className="pub-size-selector">
            <button
              type="button"
              className={`pub-action-btn pub-action-btn--edit ${editImageIndex !== null ? 'is-active' : ''}`}
              onClick={() => setEditImageIndex(editImageIndex === null ? 0 : null)}
            >
              <MdEdit />
              {editImageIndex !== null ? elakayAutoText("h_4d63c1d519408c", "Cancel Edit") : elakayAutoText("h_5301648dcf6b53", "Edit")}
            </button>

            <button
              type="button"
              className="pub-action-btn pub-action-btn--view"
              onClick={() => setViewImageModal(photos[0])}
            >
              <MdRemoveRedEye />{__elakayText("t001", "View")}
            </button>
          </div>
        )}

        {/* Upload drop zone */}
        {photos.length < maxImgSize && (
          <div
            onClick={openFilePicker}
            onDragEnter={handleHighlight}
            onDragOver={handleHighlight}
            onDragLeave={handleUnhighlight}
            onDrop={handleDrop}
            className={`pub-dropzone ${highlight ? 'is-highlight' : ''}`}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />

            <div className="pub-dropzone-title">{__elakayText("t004", "Upload image 500 × 500")}</div>
            <div className="pub-dropzone-subtitle">{__elakayText("t005", "Click here or Drag & Drop")}</div>
          </div>
        )}
      </form>

      <ErrorAlert error={error} setError={setError} duration={10000} />

      <div className="pub-page-actions">
        <button type="button" className="pub-cancel-btn" onClick={ButtonCancel}>
          {infoSource.laguangeElakay("Button", infoSource.languageAPI).cancel}
        </button>
        {photos.length === 1 ? (
          <button type="button" className="pub-submit-btn" onClick={handleSubmit}>{__elakayText("t007", "Submit")}</button>
        ) : (
          <button type="button" className="pub-submit-btn" disabled>{__elakayText("t006", "Submit (0/1)")}</button>
        )}
      </div>
    </div>
  );

  const show = () => (
    <div className="pub-page-shell">
      <div className="pub-page-header">
        <FaRegImage />
        <h3>{infoSource?.laguangeElakay?.("title", infoSource.languageAPI)?.pub500x500 || elakayAutoText("h_0fb87879bcff21", "Pub 500×500")}</h3>
      </div>
      <div className="pub-page-body">
        {nbrDayForm()}
        {ImagesForm()}
      </div>

      <ViewImageModal />
    </div>
  );

  return <div>{show()}</div>;
};

export default Pubc500x500;
